<template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>Foto</th>
          <th>
            <div>
              <button @click="agregar" type="button" class="btn-success">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          :id="'fotos' + index"
          @eliminar="eliminar"
          :defaultImage="foto.imagen"
          v-model="fotos[index]"
          is="tr-foto"
          v-for="(foto, index) in fotos"
          :key="index"
          :index="index"
        ></tr>
        <tr v-show="fotos.length === 0">
          <td colspan="2">
            <strong>No ha agregado fotos.</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    maxFotos: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data: function() {
    return {
      fotos: this.value
    };
  },
  methods: {
    agregar: function() {
      if (this.fotos.length < this.maxFotos) {
        this.fotos.push({
          imagen: ""
        });
      } else
        swal(
          "No se puede agregar más de " + this.maxFotos + " foto(s).",
          "Aviso",
          "warning"
        );
    },
    eliminar: function(index) {
      this.fotos.splice(index, 1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/MultipleFotos.vue